import { createGlobalStyle } from "styled-components";
import darkMobileBckgrnd from "../src/modules/mainApp/images/darkBackground.webp";
import darkBckgrnd from "../src/modules/mainApp/images/smoczakrainanoc.jpg";
import lightBckgrnd from "../src/modules/mainApp/images/smoczakraina.webp";
import afternoonBckgrnd from "../src/modules/mainApp/images/smoczakrainapozachodzie.webp";
import costam from "./modules/aiApp/components/Assets/backgroundMobile.jpg";
import costam1 from "./modules/aiApp/components/Assets/backgroundi.jpg";
import lightMobileBckgrnd from "../src/modules/mainApp/images/brightBackground.webp";
import afternoonMobileBckgrnd from "../src/modules/mainApp/images/dayBackgroundOrange.webp";
import costam3 from "./modules/aiApp/components/Assets/9x16_sunrise_in_space.png";


// export const GlobalStyle = createGlobalStyle`
//   html {
//     box-sizing: border-box;
//     scroll-behavior: smooth;
//     line-height: 140%;
//   letter-spacing: 0.02em;
//   font-weight: 400;
//   }
//   *,
//   ::after,
//   ::before {
//     box-sizing: inherit;
//   }
//   body {
//     background-image: url(${darkBckgrnd});
//      @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
//           background-image: url(${darkMobileBckgrnd});
//   } 
//     background-color: ${({ theme }) => theme.color.bodyBackground};
//     background-repeat: no-repeat;
//     background-size: cover; 
//     font-family: 'Montserrat', sans-serif;
//     transition: background 1s cubic-bezier(0.69, 0.15, 0.31, 0.85);

//     ${({ isBodyOverflowHidden }) => isBodyOverflowHidden && `
//       overflow: hidden;
//     `}
//          @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
//           background-size: 1000px; 
//   } 
//   @media (min-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
//          background-attachment: scroll ;
//   } 
//   }
//   ${({ isLight, isNoon, theme }) => isLight && (isNoon ? `
//    body {
//        background-image: url(${lightBckgrnd});
//         @media (max-width: ${theme.breakpoint.tabletMax}px) {
//          background-image: url(${lightMobileBckgrnd});
//   } 
//    }
// ` : `
//    body {
//        background-image: url(${afternoonBckgrnd});
//          @media (max-width: ${theme.breakpoint.tabletMax}px) {
//          background-image: url(${afternoonMobileBckgrnd});
//   } 
//    }
// `)}
// `;

export const GlobalStyle = createGlobalStyle`
  html {
    box-sizing: border-box;
    scroll-behavior: smooth;
    line-height: 140%;
  letter-spacing: 0.02em;
  font-weight: 400;
  }

  *,
  ::after,
  ::before {
    box-sizing: inherit;
  }

  body {
    position: relative;
    font-family: 'Montserrat', sans-serif;
    transition: background 1s cubic-bezier(0.69, 0.15, 0.31, 0.85);
    overflow-x: hidden;
    ${({ isBodyOverflowHidden }) =>
      isBodyOverflowHidden &&
      `
      overflow: hidden;
    `}
    /* Tło w body usunięte – teraz używamy pseudo-elementu */
    background: none;
  }

  /* Pseudo-element do stabilnego, pełnoekranowego tła */
  body::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 15%;
    z-index: -1;
    background-image: url(${darkBckgrnd});
      transition: background 1s cubic-bezier(0.69, 0.15, 0.31, 0.85);
  }

  /* Dynamiczna zmiana tła: jasno / popołudnie */
  ${({ isLight, isNoon }) =>
    isLight &&
    (isNoon
      ? `
    body::before {
      background-image: url(${lightBckgrnd});
    }`
      : `
    body::before {
      background-image: url(${afternoonBckgrnd});
    }`)}

  /* Media query – gotowa przestrzeń na dodatkowe style */
  @media (min-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
    /* Tutaj możesz dopisać dodatkowe reguły */
  }
`;
  
export const GlobalStyleAi = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
   ${({ currentPath }) =>
      ["/chatbot-history"].includes(currentPath) && `-ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    width: 0;
  }`}
  body {
    font-family: 'Poppins', serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: ${({ theme }) => theme.color.spotifyBlack};
    background-size: cover;
        ${({ currentPath }) =>
      ["/login", "/sprawdzam", "/register", "/profile", "/reset-password", "/email-verification"].includes(currentPath) // Lista ścieżek z tłem costam
        ? `background-image: url(${costam1});`
        : `background-image: none;`}
         @media (max-width: 768px) {
      ${({ currentPath }) =>
      ["/login", "/sprawdzam", "/register", "/profile", "/reset-password", "/email-verification"].includes(currentPath) // Lista ścieżek z tłem costam
        ? `background-image: url(${costam});`
        : `background-image: none;`}
  } 
         @media (min-width: 768px) {
   background-position: center;
  } 
  }

  code {
    font-family: 'source-code-pro', Menlo, Monaco, Consolas, 'Courier New', monospace;
  }
`;
//   ${({ currentPath }) =>
//  ["/home"].includes(currentPath) && `background: linear-gradient(135deg, #191414 0%,rgb(25, 53, 27) 100%);`
//}